/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

export const Tr = styled.div`
  display: grid;
  grid-template-columns: 114px 142px 100px 100px 160px 1fr;
  background: #ffffff;
  box-shadow: 0px 3px 6px #0000001a;
  border-radius: 10px;
  padding: 20px;
  gap: 30px;
  margin-bottom: 20px;

  @media (max-width: 930px) {
    display: none;
  }

  @media (max-width: 1146px) {
    grid-template-columns: repeat(6, auto);
  }
`;

export const Td = styled.div`
  display: flex;
  justify-content: ${(props) => (props.right ? 'flex-end' : 'flex-start')};
  align-items: center;
`;

export const StatusTitle = styled.div``;

export const Status = styled.div`
  min-width: 10px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: ${(props) => props.color};
  margin-right: 10px;
`;

export const DuplicateContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 110px;
  gap: 8px;
  flex-wrap: nowrap;
`;

export const DuplicateIcon = styled.i`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px !important;
`;

export const DuplicateLoading = styled.i`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px !important;
  margin: 6px 6px 0px 0px;
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 10px 0px 20px 0px;
`;

// Cards
export const Card = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 20px;
  margin-bottom: 10px;

  ${Hr} {
    border-color: #c1c1c1;
    border-style: solid;
    width: 266px;
    margin-left: -20px;
  }

  @media (min-width: 931px) {
    display: none;
  }
`;

export const CardTop = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CardLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-left: -20px;
  margin-top: 12px;
`;

export const CodeTitle = styled.div`
  font-size: 16px;
  color: #515151;
`;

export const Code = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.blue};
  margin-left: 10px;
`;

export const TitleLine = styled.div`
  font-size: 12px;
  color: #515151;
  font-weight: bold;
`;

export const DescriptionLine = styled.div`
  font-size: 12px;
  color: #515151;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
`;

export const SelectedItem = styled.div`
  min-width: 14px;
  min-height: 14px;
  width: 14px;
  height: 14px;
  border: 2px solid
    ${(props) => (props.disponibleForDownload ? '#0033FC' : 'rgba(0,0,0,.07)')};
  /* position: relative; */
  margin-right: 20px;
  margin-left: -20px;
  border-radius: 2px;
  background: ${(props) =>
    props.selectedItem && props.disponibleForDownload ? '#0033FC' : '#ffffff'};
  background: ${(props) =>
    props.selectAllInvoices && props.disponibleForDownload && '#288EFD'};
  @media (max-width: 930px) {
    margin-left: -21px;
    margin-top: 2px;
  }
`;

export const DescriptionTooltip = styled.span`
  display: inline-flex;
  width: 100%;
`;

export const BankslipInformations = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 268px;
  gap: 8px;
`;

export const ItemWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: 'Mangueira';
`;

export const Item = styled.span`
  font-family: 'Mangueira Bold';
  min-width: 48px;
`;

export const ItemDescription = styled.span``;

export const OptionsIcon = styled.div`
  margin-top: -9px;
`;
